import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';
import OptionDetails from './OptionDetails';
import { cancelRenewal } from 'components/landlord_app/rent_roll/renewals/store/actions';
import ConfirmationDialog from 'components/ui/Dialogs/ConfirmationDialog';

const CANCEL_RENEWAL_STATES = {
  confirm: 'confirm',
  error: 'error',
  success: 'success',
  loading: 'loading',
};

const YardiLeaseOptions = ({ leaseDetails, cancelRenewal, fetchRentRoll, toggleDrawer }) => {
  const yardiBased = !!leaseDetails.property && !!leaseDetails.property.yardi_based;
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [cancelDialogState, setCancelDialogState] = useState(CANCEL_RENEWAL_STATES.confirm);

  const handleCancelRenewal = async () => {
    setCancelDialogState(CANCEL_RENEWAL_STATES.loading);
    try {
      await cancelRenewal(leaseDetails.renewal_id);
      setCancelDialogState(CANCEL_RENEWAL_STATES.success);
    } catch (err) {
      setCancelDialogState(CANCEL_RENEWAL_STATES.error);
    }
  };

  const openCancelDialog = () => {
    setCancelDialogState(CANCEL_RENEWAL_STATES.confirm);
    setShowCancelDialog(true);
  };

  const closeCancelDialog = () => {
    setShowCancelDialog(false);
  };

  const closeOnCancelSuccess = () => {
    closeCancelDialog();
    const updateList = true;
    fetchRentRoll(updateList);
    toggleDrawer();
  };

  return (
    <React.Fragment>
      <ConfirmationDialog
        showConfirmationDialog={showCancelDialog}
        dialogState={cancelDialogState}
        confirm={{
          primaryBtnText: getTranslatedString(
            'landlordPortal.rentRoll.renewals.cancelConfirmation.confirm'
          ),
          headerText: getTranslatedString(
            'landlordPortal.rentRoll.renewals.cancelConfirmation.header'
          ),
          bodyText: getTranslatedString('landlordPortal.rentRoll.renewals.cancelConfirmation.body'),
          primaryAction: handleCancelRenewal,
          secondaryBtnText: getTranslatedString('close'),
          secondaryAction: closeCancelDialog,
        }}
        success={{
          primaryBtnText: getTranslatedString('landlordPortal.rentRoll.renewals.successButton'),
          headerText: getTranslatedString('landlordPortal.rentRoll.renewals.cancelRenewalSuccess'),
          bodyText: getTranslatedString(
            'landlordPortal.rentRoll.renewals.cancelRenewalSuccessBody'
          ),
          action: closeOnCancelSuccess,
        }}
        loading={{
          headerText: getTranslatedString('landlordPortal.rentRoll.renewals.loadingHeader'),
          bodyText: getTranslatedString('landlordPortal.rentRoll.renewals.doNotReload'),
        }}
        error={{
          headerText: getTranslatedString('landlordPortal.rentRoll.renewals.cancelError'),
          bodyText: getTranslatedString('landlordPortal.rentRoll.renewals.cancelErrorBody'),
          primaryBtnText: getTranslatedString('close'),
          action: closeCancelDialog,
        }}
      />
      <OptionDetails
        optionsTitle={getTranslatedString('landlordPortal.rentRoll.renewals.cancelRenewal')}
        optionDetails={getTranslatedString('landlordPortal.rentRoll.renewals.cancelRenewalDetails')}
        optionTrigger={openCancelDialog}
        buttonVerbiage={getTranslatedString('landlordPortal.rentRoll.renewals.cancelRenewal')}
        disabled={!yardiBased || !leaseDetails.editable}
      />
    </React.Fragment>
  );
};

const mapStateToProps = store => ({
  leaseDetails: store.leaseDetails.leaseDetails,
});

const mapDispatchToProps = {
  cancelRenewal,
};

export default connect(mapStateToProps, mapDispatchToProps)(YardiLeaseOptions);
